import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, timer, Subject } from 'rxjs';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'eos-timeout-window',
  templateUrl: './timeout-window.component.html',
  styleUrls: ['./timeout-window.component.css']
})
export class TimeoutWindowComponent implements OnInit {
  autoCloseTimer = 11;
  autoCloseTimer$: Subscription;
  closed = false;
  constructor(
    public modal: NgbActiveModal,
    private authService: AuthService) { }


  ngOnInit() {
    this.autoCloseTimer$ = timer(1000, 1000).subscribe(t => {
      this.autoCloseTimer--;
      if (t === 10) {
        this.logout();
        this.autoCloseTimer$.unsubscribe();
        this.modal.close();
      }
    });
  }

  logout() {
    this.modal.dismiss();
  }

  stay() {
    this.autoCloseTimer$.unsubscribe();
    this.modal.close(true);
  }
}
